import { Login, LoginForm } from 'react-admin';
import { Box, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { EnvironmentBanner } from './EnvironmentBanner';

/**
 * Ekran logowania w kolorach aplikacji.
 *
 * Domyślny ekran react-admina ma ciemnogranatowe, prawie czarne tło
 * (`radial-gradient(… #313264 … #00023b …)` w `ra-ui-materialui`
 * `auth/Login.js`), które nie pasuje do jasnej aplikacji — użytkownik
 * 01.10.2026: „menu logowania zrób w normalnym kolorze, a nie czarne”.
 * Tu: niebieski pas u góry w kolorze paska aplikacji, pod nim jasne tło
 * strony, karta z nazwą aplikacji i ikoną. Formularz i logowanie bez zmian
 * — to ten sam `LoginForm` react-admina.
 */
export const loginBackground = (theme: Theme) =>
  `linear-gradient(180deg, ${theme.palette.primary.main} 0, ${theme.palette.primary.main} 240px, ${theme.palette.background.default} 240px)`;

/**
 * Karta ma stałą szerokość, a pola zajmują ją całą. `LoginForm` ma na
 * sztywno `width: 300` (`RaLoginForm-content`), a karta była szersza (340,
 * żeby zmieścić podtytuł) — pola i przycisk dosuwały się do lewej krawędzi
 * (02.10.2026: „menu logowania nie jest wycentrowane”). Samo `width: 100%`
 * bez stałej szerokości karty rozpycha ją do naturalnej szerokości pól.
 * `sx` na samym formularzu, bo reguła z `<Login>` przegrywałaby z regułą
 * formularza o tej samej wadze.
 */
export const LOGIN_CARD_WIDTH = 340;
export const loginFormSx = { '& .RaLoginForm-content': { width: '100%' } };

export const LoginPage = () => (
  <Login
    avatarIcon={<LocalShippingIcon />}
    sx={(theme: Theme) => ({
      backgroundImage: loginBackground(theme),
      backgroundColor: theme.palette.background.default,
      '& .RaLogin-card': { width: LOGIN_CARD_WIDTH, maxWidth: 'calc(100vw - 32px)', boxShadow: theme.shadows[4] },
      '& .RaLogin-icon': { backgroundColor: theme.palette.primary.main },
    })}
  >
    {/* Na stagingu (12.10.2026) widać już przy logowaniu, że to nie
        produkcja — konta pokazowe logują się tutaj. */}
    <EnvironmentBanner />
    <Box sx={{ textAlign: 'center', px: 2, pt: 0.5 }}>
      <Typography variant="h6" component="h1">
        Marathon
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Bank zleceń i planowanie transportu
      </Typography>
    </Box>
    <LoginForm sx={loginFormSx} />
  </Login>
);
